export default {
    data() {
        return {
            memberInfo:{},
        }
    },
    created() {
        var that=this;
        axios.post('/company/privilege/souvenir').then(function (res) {
            that.memberInfo=res.data.data;
        });
    },
    mounted() {

    },
}